import React from "react";

export default function MarketplaceMetricCards({metrics, colors, onSelect, selectedKey}) {
    return <div className="row mb-4">{metrics.map((metric) => <div className="col-12 col-sm-6 col-xl-3 mb-3 mb-xl-0" key={metric.key}>
        <button type="button" className="w-100 p-0 border-0 bg-transparent text-left" onClick={() => onSelect(metric.key)} aria-pressed={selectedKey === metric.key}>
            <div className="small-box bg-white mb-0" style={{borderRadius: 16, boxShadow: "0 8px 24px rgba(0,0,0,0.08)", cursor: "pointer"}}>
                <div className="inner"><h3 style={{color: "#14151a"}}>{metric.value ?? 0}</h3><p style={{color: "#14151a", fontWeight: 700, marginBottom: 4}}>{metric.label}</p></div>
                <div className="icon" style={{color: colors.secondary}}><i className={`fas ${metric.icon}`} /></div>
            </div>
        </button>
    </div>)}</div>;
}
